module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.89889688.svg";